








import { defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import PurchaseGalleryProvidersView from "./components/PurchaseGalleryProvidersView";

export default defineComponent({
  name: "PagePurchaseGalleryProviders",
  components: { PurchaseGalleryProvidersView },
  setup(_, { root }) {
    const { authUserStrict } = useAuthUser();
    const loading = ref(true);

    const { items, enableScroll, getFirstPage, getNextPage } = usePager(page => {
      return providers.PurchasedItemsProvider.searchProviders({
        data: {
          consumerId: authUserStrict.value.id,
          page,
          sort: "PURCHASE_TIME,DESC",
        },
      });
    });

    getFirstPage()
      .then(() => {
        if (items.value.length === 1) {
          root.$router.replace({ name: "purchaseGallery", params: { providerId: items.value[0].providerId } });
        }
      })
      .finally(() => (loading.value = false));

    return { enableScroll, loading, items, getNextPage };
  },
});
